import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/assets/$assetId/transfer/new")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/transfers/new",
      search: { assetId: params.assetId },
    });
  },
});
